import React from 'react';

// componentes
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form } from 'react-bootstrap';
import { DebounceInput } from 'react-debounce-input';
import { Link } from 'react-router-dom';
import ListaCheckbox from './../../../ComponentesCadastro/ListaCheckbox';

// cria os parametros
function Parametros({
    parametros, 
    alterarParametros
}){

    // parametros
    return <div className="parametros">
        <div className="parametros-inicial">
            <Link to='/painel/pacientes/cadastrar'>
                <Button variant="padrao" className="botao-cadastrar">
                    <FontAwesomeIcon className="icone" icon={["fas", "plus"]} />
                    <span>Cadastrar Paciente</span>
                </Button>
            </Link>
            <DebounceInput 
                placeholder="Localizar paciente por nome, data de nascimento ou cpf" 
                debounceTimeout={400}
                element={Form.Control} 
                value={parametros.texto}
                onChange={(e) =>{
                    alterarParametros({...parametros, texto: e.target.value, pagina: 1})
                }}
            />
            <div className="campo-flags">
                <ListaCheckbox 
                    itens={[
                        {id: 'A', label: 'Ativos'},
                        {id: 'I', label: 'Inativos'}
                    ]}
                    value={parametros.status}
                    label='tipo-pessoa'
                    onChange={(ids) => {
                        parametros.status = ids;
                        alterarParametros({...parametros, pagina: 1});
                    }}
                />
            </div>
        </div>

    </div>

}


export default Parametros;